<template>
  <v-menu min-width="350" v-model="show" bottom left offset-y origin="top right" transition="scale-transition">
    <template v-slot:activator="{ attrs, on }">
      <v-btn icon color="primary" min-width="0" text v-bind="attrs" v-on="on">
        <v-icon>mdi-account</v-icon>
        <v-badge color="primary" v-if="onlineUsers.length > 1" overlap bordered>
          <template v-slot:badge>
            <span>{{ onlineUsers.length - 1 }}</span>
          </template>
        </v-badge>
      </v-btn>
    </template>
    <v-list :tile="false" nav class="chat-container" v-on:click.stop>
      <v-btn style="float: right" class="v-btn--icon" v-on:click="show = false" text min-width="0">
        <v-icon color="primary">mdi-close</v-icon>
      </v-btn>
      <v-list-item v-for="user in onlineUsers" :key="user.id" class="badge-mini-list">
        <div class="mini-list-row">
          <div class="badge-mini-container">
            <img :src="user.foto" alt="avatar" />
          </div>
          <div class="text">
            {{ user.username }}
            <br />
            <small>{{ user.lastTime }}</small>
          </div>
          <div class="pull-right">
            <v-icon>{{ user.icon }}</v-icon>
          </div>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "get-online-users",

  data() {
    return {
      show: false,
      onlineUsers: [],
      onlineUsersSource: null,
    };
  },

  methods: {
    connectOnlineUsers() {
      if (!this.isLoggedIn()) return;

      this.onlineUsersSource = new EventSource(
        this.authorizeLink("/auth/notify/listOnlineUserStream")
      );
      this.onlineUsersSource.addEventListener("onlineUsers", (event) => {
        try {
          this.onlineUsers = JSON.parse(event.data);
        } catch (error) {
          console.error("Invalid online users stream payload", error);
        }
      });
    },
  },
  mounted() {
    this.connectOnlineUsers();
  },
  beforeDestroy() {
    if (this.onlineUsersSource) {
      this.onlineUsersSource.close();
      this.onlineUsersSource = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.badge-mini-list {
  width: 100%;
  margin-left: 15px;
  margin-right: 15px;

  &.mini-list-row:not(:last-child):after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 15px;
    height: 1px;
    width: calc(100% - 30px);
    background-color: rgba(180, 180, 180, 0.3);
  }

  .badge-mini-container {
    width: 50px;

    img {
      width: 30px;
      height: 30px;
      border-radius: 30px;
      margin: 10px;
    }
  }

  .text {
    position: absolute;
    left: 80px;
    width: 155px;
    top: 15px;
    line-height: 20px;
  }

  .pull-right {
    width: 50px;
    position: absolute;
    right: 0px;
    top: 25px;

    i {
      top: 0px;
    }
  }
}
</style>